// SPDX-License-Identifier: FSL-1.1-Apache-2.0
/**
 * @module cx
 * @package @geenius/analytics/solidjs-css
 * @description Provides the SolidJS CSS variant with a tiny class-name
 * combiner so components can compose static stylesheet classes without
 * introducing Tailwind-specific helpers.
 */

/**
 * Joins truthy class-name fragments into a single class string.
 *
 * @param classes Candidate class-name fragments that may be falsy.
 * @returns The composed class-name string for the rendered element.
 *
 * @example
 * ```ts
 * const classes = cx('gn-analytics-card', isActive() && 'gn-analytics-card--active')
 * ```
 */
export function cx(
  ...classes: Array<string | false | null | undefined>
): string {
  return classes.filter(Boolean).join(" ");
}
